import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import Loader from '../Loader';
import Alert from 'react-s-alert';
import { Messages } from '../../constants';
import { connect } from 'react-redux';
import * as AuthActions from '../../actions/AuthActions';
import './style.scss';


class Header extends Component {


  logoutUser = ()=> {
    this.props.logout();
  }
  redirectToMailing =() => {
    Alert.info(Messages.MailingInDevelopment);
  };

  render(){

    return(
      <header className={`header header-home`}>
      <Loader />
      <nav className={`navbar navbar-default navbar-default-home`}>
        <div className="container">
          <div className="navbar-header">
            <Link to="/">
              <p className="text project-name">
                {this.props.showBackButton && (
                  <i className="fas fa-arrow-circle-left back" />
                )}
                <img
                  src="/img/logo-portal-comercial.png"
                  className="logo-portal"
                />
              </p>
            </Link>
          </div>
          <div className="navbar-collapse">
            <ul className="nav navbar-nav navbar-right">
              <li className={`dropdown dropdown-home`}>
                <Link
                  to="/login"
                  className={`dropdown-toggle dropdown-toggle-home`}
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className={`text user-name text-home`}>
                    Olá,
                    <span className="user-name-color">
                      {` ${this.props.loggedUser.profile.name}`}
                    </span>
                    <span className="caret caret-custom" />
                  </span>
                </Link>
                {this.props.loggedUser && this.props.loggedUser.photo && (
                  <img src={this.props.loggedUser.photo} className="avatar" />
                )}
                <ul className="dropdown-menu">
                  <li>
                    <a href="javascript:" onClick={this.logoutUser}>
                      Sair
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="mobile-project-name">
            <Link to="/">
              <p className="text mobile-text-project">
                {this.props.showBackButton && (
                  <i className="fas fa-arrow-circle-left back" />
                )}
                Portal <span className="constrant-color">Comercial</span>
              </p>
            </Link>
          </div>
        </div>
      </nav>
    </header>
    )
  }
}

const mapStateToProps = ({ auth }) => {
  return {
    ...auth
  };
};

export default connect(
  mapStateToProps,
  { ...AuthActions }
)(Header);
